/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__on_the_way_section__filters__infos = /** @type {(inputs: {}) => string} */ () => {
	return `Entspricht der Entfernung zwischen Ihrer Route und den vorgeschlagenen interessanten Orten.`
};

const en_route_details__on_the_way_section__filters__infos = /** @type {(inputs: {}) => string} */ () => {
	return `Corresponds to the distance between your journey and the proposed points of interest.`
};

const es_route_details__on_the_way_section__filters__infos = /** @type {(inputs: {}) => string} */ () => {
	return `Corresponde a la distancia entre tu viaje y los puntos de interés propuestos.`
};

const fr_route_details__on_the_way_section__filters__infos = /** @type {(inputs: {}) => string} */ () => {
	return `Correspond à la distance entre votre trajet et les points d'intérêt proposés.`
};

const it_route_details__on_the_way_section__filters__infos = /** @type {(inputs: {}) => string} */ () => {
	return `Corrisponde alla distanza tra il viaggio e i punti di interesse proposti.`
};

const nl_route_details__on_the_way_section__filters__infos = /** @type {(inputs: {}) => string} */ () => {
	return `Komt overeen met de afstand tussen uw reis en de voorgestelde nuttige punten.`
};

const pt_route_details__on_the_way_section__filters__infos = /** @type {(inputs: {}) => string} */ () => {
	return `Corresponde à distância entre a sua viagem e os pontos de interesse propostos.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__infos = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__on_the_way_section__filters__infos(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__on_the_way_section__filters__infos", locale)
	if (locale === "de") return de_route_details__on_the_way_section__filters__infos(inputs)
	if (locale === "en") return en_route_details__on_the_way_section__filters__infos(inputs)
	if (locale === "es") return es_route_details__on_the_way_section__filters__infos(inputs)
	if (locale === "fr") return fr_route_details__on_the_way_section__filters__infos(inputs)
	if (locale === "it") return it_route_details__on_the_way_section__filters__infos(inputs)
	if (locale === "nl") return nl_route_details__on_the_way_section__filters__infos(inputs)
	return pt_route_details__on_the_way_section__filters__infos(inputs)
};